{
  "version": 1,
  "asset_id": "3c9a112d-e1f1-45fb-8f01-7f1fe2f2c4ca",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/3c9a112d-e1f1-45fb-8f01-7f1fe2f2c4ca/esenyurt-hizli-elektrikci-7-24-dukkan-7.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/3c9a112d-e1f1-45fb-8f01-7f1fe2f2c4ca/esenyurt-hizli-elektrikci-7-24-dukkan-7.jpg",
  "original_filename": "esenyurt-hizli-elektrikci-7-24-dukkan-7.jpg",
  "size": 625598,
  "content_type": "image/jpeg",
  "created_at": "2026-09-12T10:56:21Z"
}
